/**
 * Portal
 * The ISC Portal is designed as an entrypoint for ISC to publish solutions to multiple cloud providers that are consumed by external users.  On this page, Swagger UI is already pre-authorised with your current JWT token and you can explore and try out APIs with your current user\'s credentials.  <code> !!! WARNING !!! Any command you issue from this page or using API calls will take an immediate effect on your deployments and data without any further confirmations. Please be very careful with POST and DELETE commands. </code>  If you want to use those APIs programmatically, you need to get JWT token first because it has a very limited expiration time.  There are multiple options to get JWT token from Amazon Cognito which our Cloud Portal use, the simplest one is to use curl and jq commands:  <code> TOKEN=$(curl -s \"https://cognito-idp.us-east-2.amazonaws.com/\" \\ -X POST \\ -d \'{\"AuthFlow\":\"USER_PASSWORD_AUTH\",\"ClientId\":\"5lif09dom0glg27o8ha6duu9bs\",\"AuthParameters\":{\"USERNAME\":\"<USERNAME>\",\"PASSWORD\":\"<PASSWORD>\"}}\' \\ -H \"content-type: application/x-amz-json-1.1\" \\ -H \"X-Amz-Target: AWSCognitoIdentityProviderService.InitiateAuth\" | jq -r \'.AuthenticationResult.IdToken\'  ) </code>  After you get the token, you can use it to authenticate with InterSystems Cloud Portal, for example:  <code> curl \'https://portal.live.isccloud.io/v3/api/deployments\' \\ -X \'GET\' \\ -H \'accept: application/json\' \\ -H \"Authorization: Bearer $TOKEN\" </code> 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: portal-dev@intersystems.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeploymentConfiguration } from './deploymentConfiguration';


export interface Deployment { 
    item_type?: string;
    deploymentid?: string;
    tenantid?: string;
    owner_name?: string;
    stackname?: string;
    deploymentname?: string;
    deploymentsize?: string;
    region?: string;
    cloudprovider?: Deployment.CloudproviderEnum;
    created_at?: string;
    updated_at?: string;
    status?: Deployment.StatusEnum;
    account?: string;
    deploymenttype?: string;
    offer_name?: string;
    bank_config?: boolean;
    deleted_at?: string;
    ecp_config?: boolean;
    dr_config?: boolean;
    ha_config?: Deployment.HaConfigEnum;
    hosted_zone_id?: boolean;
    hosted_zone_name?: boolean;
    is_commercial?: boolean;
    is_spot?: boolean;
    mam_status?: boolean;
    resource_role?: string;
    service_level?: string;
    service_level_urgency?: string;
    service_status?: string | boolean;
    storage_last_notify_date?: boolean;
    subscriptionid?: boolean;
    access_list?: Array<object>;
    resource_list?: { [key: string]: object; };
    configuration?: DeploymentConfiguration;
}
export namespace Deployment {
    export type CloudproviderEnum = 'aws';
    export const CloudproviderEnum = {
        Aws: 'aws' as CloudproviderEnum
    };
    export type StatusEnum = 'NEW' | 'INPROGRESS' | 'COMPLETED' | 'FAILED' | 'REFRESH' | 'DELETED';
    export const StatusEnum = {
        New: 'NEW' as StatusEnum,
        Inprogress: 'INPROGRESS' as StatusEnum,
        Completed: 'COMPLETED' as StatusEnum,
        Failed: 'FAILED' as StatusEnum,
        Refresh: 'REFRESH' as StatusEnum,
        Deleted: 'DELETED' as StatusEnum
    };
    export type HaConfigEnum = 'mirrored' | 'non-mirrored';
    export const HaConfigEnum = {
        Mirrored: 'mirrored' as HaConfigEnum,
        NonMirrored: 'non-mirrored' as HaConfigEnum
    };
}


